import { takeLatest, fork, put, call } from 'redux-saga/effects';

import { createError, resetApplicationState } from './actions';
import { USER_LOGOUT } from './constants';
import {ApiRequest} from "../../utils/api";

export function* doCallApi(globalErrorHandling, apiRequestFactory, ...params) {
	const request = apiRequestFactory.apply(undefined, params);
	try {
		const response = yield call({
			context: request,
			fn: request.execute
		});
		return { response };
	} catch (error) {
		if (globalErrorHandling === true) {
			yield put(createError(error));
		}
		return { error };
	}
}

function* doLogout(action) {
	const {
		payload: { callback }
	} = action;
	yield call(doCallApi, true, ApiRequest.logout);
	sessionStorage.removeItem('accessToken');
	sessionStorage.removeItem('accountId');
	sessionStorage.removeItem('userId');
	sessionStorage.removeItem('customerType');
	yield put(resetApplicationState());
	callback();
}

export function* root() {
	yield fork(takeLatest, USER_LOGOUT, doLogout);
}

export default [root];
